import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ServiceOverview from './components/ServiceOverview';
import QRUsage from './components/QRUsage';
import AffiliateSystem from './components/AffiliateSystem';
import CaseStudies from './components/CaseStudies';
import Pricing from './components/Pricing';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <main className="font-sans">
      <Navbar />
      <Hero />
      <ServiceOverview />
      <QRUsage />
      <AffiliateSystem />
      <CaseStudies />
      <Pricing />
      <Contact />
      <Footer />
    </main>
  );
}
